/* unplugin-vue-components disabled */import { render, staticRenderFns } from "./ContainerWithLabel.vue?vue&type=template&id=9454ac56&scoped=true"
import script from "./ContainerWithLabel.vue?vue&type=script&lang=js"
export * from "./ContainerWithLabel.vue?vue&type=script&lang=js"
import style0 from "./ContainerWithLabel.vue?vue&type=style&index=0&id=9454ac56&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "9454ac56",
  null
  
)

export default component.exports